import { render, staticRenderFns } from "./StockSearchBar.vue?vue&type=template&id=f07b8fba&scoped=true"
import script from "./StockSearchBar.vue?vue&type=script&lang=js"
export * from "./StockSearchBar.vue?vue&type=script&lang=js"
import style0 from "./StockSearchBar.vue?vue&type=style&index=0&id=f07b8fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b8fba",
  null
  
)

export default component.exports